import { useBlackWhiteListStore } from '@/entities/black-white-list'
import { useCurrentUserOtherTerminalSessionsStore, useCallSessionStartedTimestampStore } from '@/entities/call-session'
import { useCallSessionMediaStore } from '@/entities/call-session-media'
import { useCallRingingStore, useCallsStore, useTelProtocolNumberStore } from '@/entities/calls'
import { useStoreConferenceMediaStatuses, useConferenceAllowedParticipantsStore, useModeratedConferenceParticipantsSignalsStore } from '@/entities/conference-participant'
import { useStoreContacts } from '@/entities/contact'
import { useStoreGroups } from '@/entities/contact-group'
import { useStoreMediaDevices } from '@/entities/media-devices'
import { chatModel, draftModel, usePinEventsStore } from '@/entities/messages'
import { useNotificationItemStore, useStoreSettingsNotifications } from '@/entities/notification'
import { useStorePickupCall } from '@/entities/pickup-call'
import { useChatFilesMarkersStore, useNotificationPreferenceStore, useStoreLastReadEventIds, useStoreRooms } from '@/entities/room'
import { useRoomScheduleStore } from '@/entities/schedule'
import { useStoreProfile } from '@/entities/user-profile'

import { useStoreConfiguration } from '@/shared/store/configuration'
import { useStoreEnvSettings } from '@/shared/store/environment'
import { useRoomPublicIdentityStore } from '@/shared/store/public-identity'
import { useAppVersionStore } from '@/shared/store/version'

export const useStore = () => ({
  groups: useStoreGroups(),
  configuration: useStoreConfiguration(),
  contacts: useStoreContacts(),
  rooms: useStoreRooms(),
  devices: useStoreMediaDevices(),
  appVersion: useAppVersionStore(),
  lastReadEvents: useStoreLastReadEventIds(),
  pickupCalls: useStorePickupCall(),
  envSettings: useStoreEnvSettings(),
  settingsNotifications: useStoreSettingsNotifications(),
  notificationItems: useNotificationItemStore(),
  notificationPreferences: useNotificationPreferenceStore(),
  profile: useStoreProfile(),
  chatMessages: chatModel.useChatMessageStore(),
  draftMessages: draftModel.useDraftMessageStore(),
  callRinging: useCallRingingStore(),
  telProtocolNumberStore: useTelProtocolNumberStore(),
  blackWhiteList: useBlackWhiteListStore(),
  calls: useCallsStore(),
  callSessionMedia: useCallSessionMediaStore(),
  conferenceMedia: useStoreConferenceMediaStatuses(),
  currentUserOtherTerminalSessions: useCurrentUserOtherTerminalSessionsStore(),
  pinEvents: usePinEventsStore(),
  callSessionStartedTimestamp: useCallSessionStartedTimestampStore(),
  chatFilesMarkers: useChatFilesMarkersStore(),
  allowedParticipants: useConferenceAllowedParticipantsStore(),
  moderatedConferenceParticipantsRequests: useModeratedConferenceParticipantsSignalsStore(),
  roomSchedule: useRoomScheduleStore(),
  publicIdentities: useRoomPublicIdentityStore(),
})
